const format = (date) => {
  const d = new Date(date);
  let month = `${d.getMonth() + 1}`;
  let day = `${d.getDate()}`;
  const year = d.getFullYear();

  if (month.length < 2) { month = `0${month}`; }
  if (day.length < 2) { day = `0${day}`; }

  return [year, month, day].join('-');
};

const isBefore = (before, after) => {
  const beforeDate = new Date(before);
  const afterDate = new Date(after);
  return beforeDate <= afterDate;
};


const date = {
  format,
  isBefore,
};
export default date;
